import { render } from "./ModalBookshelf.vue?vue&type=template&id=377ffe53&scoped=true"
import script from "./ModalBookshelf.vue?vue&type=script&lang=js"
export * from "./ModalBookshelf.vue?vue&type=script&lang=js"

import "./ModalBookshelf.vue?vue&type=style&index=0&id=377ffe53&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377ffe53"]])

export default __exports__